import { createPortal } from "react-dom";
import MealsInYourAreaForm from "./MealsInYourAreaForm";

interface Props {
  container: HTMLElement;
};
export default function EmailZipPortal({ container }: Props) {
  return createPortal(<MealsInYourAreaForm />, container);
}